import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useToursStore = defineCollectionStore({
	id: 'tours',
	endpoint: '/api/tours',
	dataKey: 'tours',
	wrapRecords: true,
	errorLabel: 'Fetch Tours Error: ',
	fetchName: 'fetchTours',
	archive: {
		toggleName: 'toggleArchivedTours',
		archivedDataKey: 'archivedTours',
		archivedFetchName: 'fetchArchivedTours',
		archivedEndpoint: (year) => `/api/archive/${year}/tours`,
		getters: {
			toursData: { role: 'data', fallback: () => ({ records: [] }) },
		},
	},
});
